<template>
  <div>
    <form @submit="createEvent">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="eventName">Event Name</label>
                <input
                  type="text"
                  name="name"
                  v-model.trim="eventForm.name"
                  placeholder="Event Name"
                  class="form-control"
                  v-validate="'required'"
                  data-vv-as="event name"
                />
                <div class="invalid-feedback" v-if="veeErrors.first('name')">
                  {{ veeErrors.first("name") }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group row">
                <div class="col-6">
                  <DatePicker
                    class=""
                    label="Start Date"
                    placeholder="Select date"
                    v-model="eventForm.startDate"
                    :custom="true"
                    :disabledDate="handleDisabledDate"
                  />
                </div>
                <div class="col-6">
                  <DatePicker
                    label="End Date"
                    placeholder="Select date"
                    v-model="eventForm.endDate"
                    :custom="true"
                    :disabledDate="handleDisabledDate"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group row">
                <div class="col">
                  <label for="startTime">Start Time</label>
                  <flat-pickr
                    :config="fromTimeConfig"
                    class="date-picker form-control bg-white"
                    placeholder="Select time"
                    name="startTime"
                    v-model="eventForm.startTime"
                  />
                </div>
                <div class="col">
                  <label for="endTime">End Time</label>
                  <flat-pickr
                    :config="toTimeConfig"
                    class="date-picker form-control bg-white"
                    placeholder="Select time"
                    name="endTime"
                    v-model="eventForm.endTime"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="eventName">Event Photo or Poster</label>
                <div class="row">
                  <div class="col-9">
                    <input
                      type="text"
                      name="featuredImage"
                      v-model="eventForm.featuredImage"
                      class="form-control"
                      disabled
                    />
                  </div>
                  <div class="col-3">
                    <ActionButton
                      :theme="{ primary, secondary, danger, event }"
                      @customEvent="handleShowMedia"
                      label="Media Gallery"
                      style="width: auto; margin-top: 0; margin-left: auto;"
                    />
                  </div>
                </div>
                <span class="small"
                  >A Default Photo will be used if Event Photo is not
                  picked</span
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="eventDescription">Event Details</label>
                <vue-editor
                  v-model="eventForm.description"
                  useCustomImageHandler
                  ref="vueEditor"
                  @image-added="handleImageAdded"
                  @image-removed="handleImageRemoved"
                  :editorOptions="editorOptions"
                  @text-change="handleTextChange"
                  @selection-change="onSelection"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group text-right mb-0">
                <ActionButton
                  :label="null"
                  :theme="{ primary, secondary, event, danger }"
                  type="submit"
                  style="max-width: 7em; margin-left: auto; margin-bottom: 0;margin-top: 0;"
                  :disabled="loader"
                >
                  <Spinner v-if="loader" theme="currentColor" />
                  <span v-else>
                    {{ btnLabel }}
                  </span>
                </ActionButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <MediaGalleryModal
      v-if="showModal"
      @response="handleResponse"
      @close="handleCloseMedia"
    />
  </div>
</template>

<script>
import moment from "@/helpers/moment";
import { dateToday } from "@/helpers/date";
import { socketSender } from "@/helpers/socket";
import editor from "@/helpers/editor";

const Spinner = () => import("@/components/Spinner");
const ActionButton = () => import("@/components/ActionButton");
const MediaGalleryModal = () =>
  import("@/components/media-gallery/MediaGalleryModal");
const DatePicker = () => import("@/components/datetimepicker/DatePicker");
const flatPickr = () => import("vue-flatpickr-component");

require("flatpickr/dist/flatpickr.css");

export default {
  name: "AddNewEvent",
  components: {
    ActionButton,
    flatPickr,
    DatePicker,
    MediaGalleryModal,
    Spinner
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [editor],
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  created() {
    this.editSelectedEvent();
  },
  data() {
    return {
      loader: false,
      btnLabel: "Create",
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      fromDateConfig: {
        dateFormat: "M d, Y",
        minDate: "today",
        defaultDate: "today"
      },
      toDateConfig: {
        dateFormat: "M d, Y",
        minDate: "today",
        defaultDate: "today"
      },
      fromTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "h:i K"
      },
      toTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "h:i K",
        minTime: moment().format("h:mm:ss A")
      },
      eventForm: {
        name: null,
        startDate: moment(dateToday()).format("MMM DD, YYYY"),
        startTime: moment(dateToday()).format("h:mm:ss A"),
        endDate: moment(dateToday()).format("MMM DD, YYYY"),
        endTime: moment(dateToday()).format("h:mm:ss A"),
        featuredImage: null,
        description: null
      },
      editEvent: false,
      editEventId: null,
      media: {},
      disabledDates: {},
      showModal: false,
      currentUser:
        this.$store.getters.getUser.firstName +
        " " +
        this.$store.getters.getUser.lastName,
      editorOptions: {
        modules: {
          clipboard: {
            matchVisual: false
          }
        }
      }
    };
  },
  methods: {
    handleResponse(obj) {
      this.media = obj;
      // update eventform.featuredimage state here
      // user media.original for now
      this.eventForm.featuredImage = this.media.original;
    },
    handleShowMedia() {
      this.showModal = true;
      this.$emit("toggleScroll", { scroll: false });
    },
    handleCloseMedia() {
      this.showModal = false;
      this.$emit("toggleScroll", { scroll: true });
    },
    handleTogglePasswordClick() {
      this.isToggled = !this.isToggled;
    },
    editSelectedEvent() {
      if (this.singleRecord) {
        let singleEvent = this.singleRecord;
        this.eventForm.name = singleEvent.name;
        this.eventForm.startDate = moment(singleEvent.startDate).format(
          "MMM DD, YYYY"
        );
        this.eventForm.startTime = moment(singleEvent.startDate).format(
          "h:mm:ss A"
        );
        this.eventForm.endDate = moment(singleEvent.endDate).format(
          "MMM DD, YYYY"
        );
        this.eventForm.endTime = moment(singleEvent.endDate).format(
          "h:mm:ss A"
        );
        this.eventForm.description = singleEvent.description;
        this.eventForm.featuredImage = singleEvent.featuredImage;
        this.editEventId = singleEvent.id;
        this.editEvent = true;
        this.btnLabel = "Update";
      }
    },
    async createEvent(event) {
      try {
        this.loader = true;
        event.preventDefault();
        let form = {};
        form.name = this.eventForm.name;
        form.startDate = this.eventForm.startDate;
        form.startTime = this.eventForm.startTime;
        form.endDate = this.eventForm.endDate;
        form.endTime = this.eventForm.endTime;
        form.description = this.eventForm.description;
        form.featuredImage = this.eventForm.featuredImage;
        var through = true;
        let isValid = await this.$validator.validateAll();

        if (!isValid) {
          throw {
            type: "warning",
            title: "warning",
            error: new Error("Please fill the required fields")
          };
        }

        if (
          moment(form.startDate).isSame(form.endDate, "day") &&
          moment(form.startTime, "h:mm A") >= moment(form.endTime, "h:mm A")
        ) {
          through = false;
        } else if (moment(form.startDate).isAfter(form.endDate, "day")) {
          through = false;
        }

        if (through == false) {
          throw {
            type: "warning",
            title: "warning",
            error: new Error("Please select proper Start and End date/time")
          };
        }
        let result = {};
        let logContent = "";
        if (this.editEvent == false) {
          /**
           * SOCKET: New event log
           */
          logContent = `${this.currentUser} added a new event named ${form.name} that will be held on ${form.startDate}`;
          result = await this.$store.dispatch("postEvent", form);
        } else {
          logContent = `${this.currentUser} updated an event named ${form.name} that will be held on ${form.startDate}`;
          let data = {
            form: form,
            id: this.editEventId
          };
          result = await this.$store.dispatch("patchEvent", data);
        }
        socketSender("newEvent", logContent);

        if (result.data.data.id) {
          await this.$toastr.success("Your changes are saved", "Success");
          await this.$store.dispatch("EVENT_LIST_RESET", "");
          await this.$store.dispatch("EVENT_LIST_PAGINATE", "");
          this.$emit("close");
        }
        if (this.$router.currentRoute.name !== "events") {
          this.$router.push("/admin/events");
        }
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      } finally {
        this.loader = false;
      }
    },
    handleDisabledDate(date) {
      var day = moment(date).format("MMMM D, YYYY");
      var cond;
      if (this.disabledDates[day] !== null) {
        cond = this.disabledDates[day];
      }
      cond =
        this.disabledDates[day] ||
        (date.getTime() < new Date().getTime() &&
          date.toLocaleDateString() !== new Date().toLocaleDateString());
      return cond;
    }
  }
};
</script>

<style lang="scss">
.flatpickr-mobile {
  padding: 10px !important;
}
.ql-snow {
  .ql-editor {
    & img {
      display: initial;
      height: auto;
      max-width: 100%;
    }
    a {
      color: var(--primary, $brand-primary);
    }
  }
  .ql-tooltip {
    left: 0 !important;
  }
}

.form-group {
  .password-wrapper {
    position: relative;
    img {
      cursor: pointer;
      position: absolute;
      right: 0.75em;
      top: 11px;
      transition: all 0.2s ease;
      &:hover,
      &.is-visible {
        filter: brightness(50%);
      }
    }
  }
  label {
    font-weight: 500;
    font-size: $font-size-xs;
  }
  input,
  textarea {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
  }
  ul {
    font-size: $font-size-xs;
  }
}

.dropdown-toggle::after {
  display: none;
}
.editr--content {
  font-size: 12px;
}
</style>
